import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';

export const sendCommunicationModalInitValue = {
  data: {
    recipientsCount: 0,
    recipientSource: '',
    recipients: [],
    selectedRecipientOptions: [],
    partnerOptions: [],
    selectedPartnerCategoryOption: null,
    partnerCategoryOptions: [],
    subject: '',
    body: '',
    attachments: [],
    testEmailRecipient: '',
    isValidTestEmailRecipient: false,
    hasDefaultRecipient: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal: () => {},
    handleChangeRecipientSource: () => {},
    handleAddRecipient: () => {},
    handleRemoveRecipient: () => {},
    handleSearchPartnerByTerm: async (): Promise<
      CustomAsyncSelectOption[] | undefined
    > => undefined,
    handleChangeCategory: () => {},
    handleRemoveCategoryRecipient: () => {},
    handleChangeSubject: () => {},
    handleChangeBody: () => {},
    handleAddAttachments: () => {},
    handleRemoveAttachment: () => {},
    handleChangeTestEmailRecipient: () => {},
    handleSendTestEmail: () => {},
    handleSendCommunication: () => {},
  },
};
